import React, { useContext, useEffect, useState } from 'react';
import { Box,Autocomplete, Grid, Typography, Button, Divider, CircularProgress, Modal, TextField, MenuItem } from '@mui/material';
import { Add, Close } from '@mui/icons-material';
import {Controller,FormProvider,useForm} from 'react-hook-form';
import { BookingDataContext, DataContext, StepperDataContext } from './UpdateBooking';
import { BookingService } from '../Service';
import AddAddress from './AddAddress';
import { isMobile } from 'react-device-detect';
import ExpertAndServices from './ExpertAndServices';
import { useParams } from 'react-router-dom';
import BookingCart from './BookingCart';
import { custom } from 'zod';


const InitiateBooking = () => {
    
    const { id } = useParams();
    const { 
        isLoadingCustomerList, 
        customerList, 
        addressList, 
        setAddressList ,
        expertList,
    } = useContext(DataContext);
    
    const { 
        activeStep, 
        handleBack,
        handleComplete 
    } = useContext(StepperDataContext);
    
    const { 
        bookingInitiationData, 
        setBookingInitiationData,
        expertDetails,
        setExpertDetails,
    } = useContext(BookingDataContext);

    const InitiatebookingFormMethod = useForm({
        mode: 'onChange',
        defaultValues: bookingInitiationData
    });
    const { control, handleSubmit, watch, formState: { errors, isDirty } ,reset,setValue} = InitiatebookingFormMethod
    const [isLoadingAddressList, setIsLoadingAddressList] = useState(false);
    const [addNewAddress, setAddNewAddress] = useState(false);

    // Update form when bookingInitiationData changes (e.g., when editing existing booking)
    useEffect(() => {
        if (Object.keys(bookingInitiationData).length > 0) {
            reset(bookingInitiationData, { keepDirty: false });
        }
    }, [bookingInitiationData, reset]);

    // Watch for customer selection
    const selectedCustomer = watch('customer');

    // Fetch address list when customer changes
    const fetchAddressList = async () => {
        if (!selectedCustomer?.id) return;
        
        setIsLoadingAddressList(true);
        try {
            const addressListResponse = await BookingService.getAddressList(selectedCustomer.id);
            if (addressListResponse.success === 1) {
                setAddressList(addressListResponse.data);
            }
        } catch (error) {
            console.error("Error fetching address list:", error);
        } finally {
            setIsLoadingAddressList(false);
        }
    };

    // Fetch addresses when customer changes
    useEffect(() => {
        if (selectedCustomer?.id) {
            // Check if this is triggered by a customer change or just returning to step 1
            const previousCustomerId = bookingInitiationData.customer?.id;
            
            // Only reset the address if it's a new customer selection
            if (!previousCustomerId || previousCustomerId !== selectedCustomer.id) {
                setValue('selected_address', '');
                // Reset address fields
                setValue('address', '');
                setValue('houseFlatBlockNo', '');
                setValue('apartmentRoadArea', '');
                setValue('city', '');
                setValue('latitude', '');
                setValue('longitude', '');
                setValue('pincode', '');
                setValue('state', '');
                setValue('landmark', '');
            }
            
            fetchAddressList();
        }
    }, [selectedCustomer?.id]);

    // Watch for address selection
    const selectedAddress = watch('selected_address');

    // Update address fields when address selection changes
    useEffect(() => {
        if (selectedAddress?.id) {
            setValue('address', selectedAddress.address);
            setValue('houseFlatBlockNo', selectedAddress.houseFlatBlockNo);
            setValue('apartmentRoadArea', selectedAddress.apartmentRoadArea);
            setValue('city', selectedAddress.city);
            setValue('latitude', selectedAddress.latitude);
            setValue('longitude', selectedAddress.longitude);
            setValue('pincode', selectedAddress.pincode);
            setValue('state', selectedAddress.state);
            setValue('landmark', selectedAddress.landmark);

            if(selectedCustomer?.id > 0 && selectedAddress?.id > 0){
                fetchCartDetails();
                
            }
        } else {
            // Don't clear address fields if we're in edit mode and have existing values
            if (!id || !bookingInitiationData.address) {
                setValue('address', '');
                setValue('houseFlatBlockNo', '');
                setValue('apartmentRoadArea', '');
                setValue('city', '');
                setValue('latitude', '');
                setValue('longitude', '');
                setValue('pincode', '');
                setValue('state', '');
                setValue('landmark', '');
            }
        }
    }, [selectedAddress]);

    // Handle form submission
    const completeStep1 = async(data) => {
        console.log("submitted initiation data:",data);
        const modifiedServices = [];
        data.services.map((service)=>{
            const requiredData = {
                provoiderServiceId:service.id,
                providerId:data.serviceExpert,
                quantity:service.quantity
            }
            modifiedServices.push(requiredData);
        });
        const requiredCartData = {
            "customerId": selectedCustomer.id,                            // Customer Id required for only admin      
            "services": modifiedServices,                                // Array of services
        }
        console.log("requiredCartData:",requiredCartData);
        const createCartResponse = await BookingService.createNewCart(requiredCartData);
        console.log("createCartResponse:",createCartResponse);
        // setBookingInitiationData({...bookingInitiationData, ...data});
        // handleComplete();
    };

    // Handle address modal close
    const handleModalClose = async () => {
        await fetchAddressList();
        setAddNewAddress(false);
    };

    // Helper function to format customer name
    const getFullName = (profile) => {
        if (!profile) return '';
        return [profile.firstName, profile.middleName, profile.lastName]
            .filter(Boolean)
            .join(' ');
    };
    
    
    const [openExistingCartModal,setOpenExistingCartModal] = useState(false);
    const [existingCart,setExistingCart] = useState([]);
    const onCloseCartModal = () => {
        setOpenExistingCartModal(false);
    }
    const fetchCartDetails = async ()=>{
        const response = await BookingService.getCartDetails({
            customerId:selectedCustomer?.id,
            addressId:selectedAddress?.id
        });
        console.log("cart details resposne:",response);
        if(response.success == '1'){
            const cartList = response.data;
            if(cartList.length > 0){
                setExistingCart(cartList);
                setOpenExistingCartModal(true);
            }
        }else if(response.success == '0'){
            setExistingCart([]);
            setOpenExistingCartModal(false); 
        }
    }
  return (
    <>
        <FormProvider {...InitiatebookingFormMethod}>
            <Box component={'form'} onSubmit={handleSubmit(completeStep1)} sx={{pb:'1%'}}>
                <Grid container>
                    <Grid item lg={9} xs={12} sx={{margin:'auto'}}>
                        {/* first container....customer selection */}
                        <Grid container spacing={2} >
                        {/* ............left section................... */}
                            <Grid item xs={12} lg={5}>
                                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',mb:'1%'}}>Select Customer<span style={{color:'#d32f2f'}}>*</span></Typography>
                                <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                                <Controller
                                    name="customer"
                                    control={control}
                                    rules={{
                                    required: 'Select customer',
                                    validate: (value) => (value && Object.keys(value).length > 0) || 'Select customer'
                                    }}
                                    // defaultValue={null}  // Set a default value
                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <Autocomplete
                                        fullWidth
                                        options={customerList || []}
                                        getOptionLabel={(option) => {
                                        if (!option) return '';
                                        const profile = option.profile || {};
                                        const fullName = getFullName(profile);
                                        return fullName ? `${fullName} (${option.mobileNumber || ''})` : '';
                                        }}
                                        value={value}
                                        onChange={(event, newValue) => {
                                        onChange(newValue);
                                        }}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            placeholder='Enter customer name or mobile Number'
                                            variant="outlined"
                                            error={!!error}
                                            InputProps={{
                                            ...params.InputProps,
                                            style: { fontSize: '0.75rem', color: '#000' },
                                            placeholder: 'Enter customer name or mobile Number'
                                            }}
                                        />
                                        )}
                                        // Custom styling for the dropdown items
                                        renderOption={(props, option) => {
                                        const profile = option.profile || {};
                                        const fullName = getFullName(profile);
                                        return (
                                            <MenuItem 
                                            {...props} 
                                            style={{ 
                                                fontSize: '0.8rem',
                                                padding: '8px 16px',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}
                                            >
                                            <Box style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Box style={{ fontWeight: '600',color:'#3e3e3e' }}>
                                                {fullName}
                                                {option.isTester && 
                                                    <span style={{ 
                                                    marginLeft: '8px', 
                                                    background: '#ffecb3', 
                                                    padding: '1px 4px', 
                                                    borderRadius: '4px',
                                                    fontSize: '0.65rem'
                                                    }}>
                                                    Tester
                                                    </span>
                                                }
                                                <span style={{marginLeft: '8px', fontSize: '0.7rem', color: '#666' }}>
                                                    ({option.mobileNumber})
                                                </span>
                                                </Box>
                                                
                                            </Box>
                                            </MenuItem>
                                        );
                                        }}
                                        isOptionEqualToValue={(option, value) => {
                                        if (!option || !value) return false;
                                        return option.id === value.id;
                                        }}
                                        noOptionsText={<span style={{ fontSize: '0.75rem' }}>No customers found</span>}
                                        ListboxProps={{
                                        style: {
                                            maxHeight: '250px',
                                            fontSize: '0.8rem'
                                        }
                                        }}
                                        PaperProps={{
                                        style: {
                                            marginTop: '4px',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
                                        }
                                        }}
                                    />
                                    )}
                                />
                                {isLoadingCustomerList && <CircularProgress/> }
                                </Box>
                            </Grid>
                            <Grid item xs={0} lg={2}/>
                            <Grid item xs={12} lg={5}>
                                <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:'1%'}}>
                                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!selectedCustomer && 'lightGray'}}>Select Address<span style={{color:!selectedCustomer ?'lightGray':'#d32f2f'}}>*</span></Typography>
                                <Button disabled={!bookingInitiationData.customer && !selectedCustomer?.profile} size='small' variant='contained' onClick={()=>setAddNewAddress(true)} startIcon={<Add sx={{fontSize:'.85rem!important'}}/>} sx={{height:'fit-content',fontSize:'x-small',p:'.5% 1.25%'}}>Add New Address</Button>
                                </Box>
                                <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                                <Controller
                                    name="selected_address"
                                    control={control}
                                    rules={{
                                    validate: (value) => {
                                        // const mode = addressMode;
                                        if (!value) return 'Please select an address';
                                        return true;
                                    }
                                    }}
                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    // use Autocomplete component for address
                                    <Autocomplete
                                        fullWidth
                                        disabled={!bookingInitiationData.customer && !selectedCustomer}
                                        autoComplete={false}
                                        options={addressList || []}
                                        getOptionLabel={(option) => {
                                        if (!option) return '';
                                        const address = option.address || '';
                                        return address ? `${address}` : '';
                                        }}
                                        value={value}
                                        onChange={(event, newValue) => {
                                        onChange(newValue);
                                        }}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            placeholder='Select an address from the list'
                                            variant="outlined"
                                            error={!!error}
                                            helperText={error?.message}
                                            InputProps={{
                                            ...params.InputProps,
                                            style: { fontSize: '0.75rem',color:'#000' }, // Adjust size as needed
                                            placeholder:'Select an address from the list'
                                            }}
                                        />
                                        )}
                                        isOptionEqualToValue={(option, value) => {
                                        if (!option || !value) return false;
                                        return option.id === value.id;
                                        }}
                                        noOptionsText={<span style={{ fontSize: '0.75rem' }}>No Address found</span>}
                                        renderOption={(props, option) => {
                                        return (
                                            <MenuItem {...props} style={{ fontSize: '0.8rem', padding: '8px 16px', }}>
                                            <Box style={{ display: 'flex'}}>
                                                <Box style={{ fontWeight: '600',color:'#3e3e3e' ,
                                                whiteSpace: 'normal', // Allows text to wrap
                                                wordBreak: 'break-word', // Prevents overflow for long words}}>
                                                }}>
                                                {option.address}
                                                <Box component={'span'}>
                                                    {option.addressType=='1'&&<Typography variant='caption' sx={{fontSize:'xx-small',bgcolor:'#E3F2FD',color:'#696969',textTransform:"uppercase",p:'.5% 1%',lineHeight:1.3,borderRadius:'.15rem',ml:1}}>
                                                    {'Home'}
                                                    </Typography>}
                                                    {option.addressType=='2'&&<Typography variant='caption' sx={{fontSize:'xx-small',bgcolor:'#E8F5E9',color:'#696969',textTransform:"uppercase",p:'.5% 1%',lineHeight:1.3,borderRadius:'.15rem',ml:1}}>
                                                    {'Work'}
                                                    </Typography>}
                                                    {option.addressType=='3'&&<Typography variant='caption' sx={{fontSize:'xx-small',bgcolor:'#F3E5F5',color:'#696969',textTransform:"uppercase",p:'.5% 1%',lineHeight:1.3,borderRadius:'.15rem',ml:1}}>
                                                    {'Other'}  
                                                    </Typography>}
                                                </Box>
                                                </Box>
                                                
                                            </Box>
                                            </MenuItem>
                                        );
                                        }}
                                    />
                                    )}
                                />
                                {isLoadingAddressList && <CircularProgress/> }
                                </Box>
                            </Grid>
                        </Grid>

                        <Divider sx={{my:'2%',borderBlockStyle:'dashed',borderBlockWidth:'1px'}}/>
                        
                        <ExpertAndServices completeStep1={completeStep1}/>
                    </Grid>
                </Grid>
                {/* =======Form Action Button Section ========*/}
                <Box sx={{display:'flex',justifyContent:'center',gap:2,mt:'.5%'}}>
                    <Button disabled={activeStep === 0} onClick={handleBack} variant='contained' color='secondary'>Back</Button>
                    <Button disabled={!isDirty} type='submit' variant='contained' color='primary'>Save & Next</Button>
                </Box>
            </Box>
        </FormProvider>

        {/* ================ Add Customer Address Modal=============== */}
        <Modal
            open={addNewAddress}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ overflow: "scroll" }}
        >
            <Box sx={{
            position: 'absolute',
            top: (isMobile) ? '80%' : '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            // border: '2px solid #ddd',
            // boxShadow: 24,
            p: 0,}}
            width={(isMobile) ? "95%" : "50%"}
            borderRadius={2}
            >
            <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:'1%',p:'1%',borderBottom:'1px solid #ddd'}}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600,color:'#3e3e3e'}}>Add New Address</Typography>
                <Button size='small' variant='outlined' color='error' startIcon={<Close/>} onClick={handleModalClose}>close</Button>
            </Box>
            <AddAddress customer= {selectedCustomer} onClose ={()=>handleModalClose()}/>
            </Box>
        </Modal>
        {/* ============= Modal For checking Existing Cart ============= */}
        <Modal
            open={openExistingCartModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{
                position: 'absolute',
                top: (isMobile) ? '80%' : '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                // border: '2px solid #ddd',
                // boxShadow: 24,
                p: 0
            }}
                width={(isMobile) ? "95%" : "60%"}
                borderRadius={2}
            >
                <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:'1%',p:'1%',borderBottom:'1px solid #ddd'}}>
                    <Typography sx={{fontSize:'0.85rem',fontWeight:600,color:'#3e3e3e'}}>Customer Cart</Typography>
                    <Button size='small' variant='outlined' color='error' startIcon={<Close/>} onClick={onCloseCartModal}>close</Button>
                </Box>
                <Box sx={{
                    maxHeight: '80vh',
                    overflowY: 'auto',
                }}>                    
                    <BookingCart existingCart={existingCart} onClose={onCloseCartModal} />
                </Box>
            </Box>
        </Modal>
      </>
  );
}

export default InitiateBooking;
